import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import JourneyBasicComponent from './journey-Basic.info';
import JourneyAddressComponent from './Journey-address.component';
import ManagementJourneyLeg from './Journeytype/journeyLg';

export const JourneyComponent = ({ ShippingStatusId, orderStatus, customers, salesOrders, selectedOrder, onInnerBasicFormChange, back, handleFormSubmit }: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Journey Information',
            component: <JourneyBasicComponent

                orderStatus={orderStatus}
                ShippingStatusId={ShippingStatusId}
                salesOrders={salesOrders}
                selectedOrder={selectedOrder}
                onInnerBasicFormChange={onInnerBasicFormChange} />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Address Information',
            component: <JourneyAddressComponent

                selectedOrder={selectedOrder} />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Journey Legs',
            component: <ManagementJourneyLeg

                selectedOrder={selectedOrder} />,
            isVisible: true,
        }
    ]
    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default JourneyComponent;